<h2>Nearby suburbs serviced by our {{location.name}} storage facility</h2>

<div [ngStyle]="{'max-height': height}">
	<p #inner>
		{{location.nearby}}
	</p>
</div>

<p>Show full list of nearby suburbs serviced | <a (click)="toggle()">Click here</a>
